import { GET_CENTROS, CREATE_CENTRO, COPY_CENTRO, DELETE_CENTRO } from '../constants/action_types';

const initialState = { centros: [], refresh: false, isLoading: false };

export default function (state = initialState, action) {


    switch (action.type) {
        case GET_CENTROS:

            return { ...state, isLoading: true };

        case GET_CENTROS + "_SUCCESS":

            return { centros: action.payload.data, refresh: false, isLoading: false };

        case CREATE_CENTRO + "_SUCCESS":
        case COPY_CENTRO + "_SUCCESS":
        case DELETE_CENTRO + "_SUCCESS":

            return { centros: [], refresh: true, isLoading: false };

        default:

            return state;
    }
}